<template>
  <div class="d-flex align-items-center vh-100 overflow-hidden">
    <div class="container-fluid">
      <slot />
    </div>
  </div>
</template>

<script setup></script>
